// extracted by mini-css-extract-plugin
module.exports = {"imgHero":"home_imgHero__2AIhj","gridCategory":"home_gridCategory__eingn","footer":"home_footer__9eVvI"};